/**
 * Interviewer related constants for the typescript frontend for the interview app
 */
import { Env } from '../Env';

// Default expiration time for Daily.co rooms and tokens (50 minutes in seconds)
export const DAILY_EXPIRY_TIME_SECONDS = 50 * 60;

// The PROD_SOFT_SKILLS_INTERVIEW_TEMPLATE_ID is not really soft skills interview template, it is for MOVE Program AI Trainer Interview
export const PROD_SOFT_SKILLS_INTERVIEW_TEMPLATE_ID = 'a9e1bde2-2a46-482d-a4ce-6ed1a866d085';
export const STAGING_SOFT_SKILLS_INTERVIEW_TEMPLATE_ID = '050e44f5-9ed7-48d0-b0a1-6715edcc20b7';
export const LOCAL_SOFT_SKILLS_INTERVIEW_TEMPLATE_ID = '4379bb11-bddd-4141-8b9d-b9a1e18ef6e8';

export const getDefaultInterviewTemplateId = () => {
  const env = Env.NEXT_PUBLIC_APP_ENVIRONMENT;

  switch (env) {
    case 'production':
      return PROD_SOFT_SKILLS_INTERVIEW_TEMPLATE_ID;
    case 'staging':
      return STAGING_SOFT_SKILLS_INTERVIEW_TEMPLATE_ID;
    case 'test':
    case 'development':
      return LOCAL_SOFT_SKILLS_INTERVIEW_TEMPLATE_ID;
    default:
      return PROD_SOFT_SKILLS_INTERVIEW_TEMPLATE_ID;
  }
};
